// Lets a shopper pick a shade by clicking its photo in the PDP gallery, not just via the
// dropdown/swatch picker. Reuses the theme's own variant-selection code path
// (product-template.liquid's onVariantChange, bound on #product's 'change' event) by
// firing a real, native click/change event on the matching control — this file never
// re-implements price/SKU/cart updates itself.
//
// Each product section emits its own #ThumbShadeMap-<sectionId> JSON island (see
// product-template.liquid) mapping a media id to {optionName: value}, built from each
// variant's linked image. Assumes one image per shade (verified against live Majirouge/
// Koleston catalog data, 2026-09-25, zero sharing); if two variants ever share one image,
// the later one silently wins the map entry.
//
// A JSON island (inert data), not an executed script, so it survives the "combined
// listing" section-replace path in product-template.liquid: an injected <script> would
// not re-run via innerHTML/replaceWith, but this file re-reads the (fresh) JSON on every
// click instead of caching it.
//
// KEEP IDENTICAL: normalizeMediaId / optionsToApply are mirrored in
// tests/pdp-gallery-variant-select.mjs for unit tests. Change here, run the mirror-drift
// test suite, then mirror.
(function () {
  if (window.__pdpGalleryVariantSelectBound) return;
  window.__pdpGalleryVariantSelectBound = true;

  function normalizeMediaId(rawId) {
    return String(rawId || '').replace(/^media/, '');
  }

  function optionsToApply(map, rawId) {
    var entry = map[normalizeMediaId(rawId)];
    if (!entry) return [];
    return Object.keys(entry)
      .filter(function (name) { return entry[name] !== null && entry[name] !== undefined; })
      .map(function (name) { return { name: name, value: entry[name] }; });
  }

  function readMap(sectionId) {
    var el = document.getElementById('ThumbShadeMap-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Matches by the control's real `name="options[...]"` attribute, not position — this
  // theme's swatch and dropdown options don't share one wrapper class to index off, and
  // matching by name is immune to swatch/dropdown ordering anyway.
  function applyOption(scope, name, value) {
    var attrName = 'options[' + name + ']';

    var radios = scope.querySelectorAll('input.swatchInput[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].getAttribute('name') === attrName && radios[i].value === value) {
        radios[i].click();
        return;
      }
    }

    var selects = scope.querySelectorAll('select.single-option-selector');
    for (var j = 0; j < selects.length; j++) {
      if (selects[j].getAttribute('name') === attrName) {
        var hasOption = false;
        for (var k = 0; k < selects[j].options.length; k++) {
          if (selects[j].options[k].value === value) { hasOption = true; break; }
        }
        if (hasOption) {
          selects[j].value = value;
          selects[j].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.pr_thumb');
    if (!thumb) return;

    var target = thumb.getAttribute('data-target');
    if (!target) return;

    var scope = thumb.closest('[data-section-id]') || document;
    var sectionId = scope.dataset ? scope.dataset.sectionId : null;
    if (!sectionId) return;

    var map = readMap(sectionId);
    if (!map) return;

    var options = optionsToApply(map, target);
    if (!options.length) return;

    // Multi-option products only: if a photo maps to more than one option, each change
    // is applied in turn. The theme's own fast-update path handles this fine for the
    // (single-option, most common) shade-only case this was built for; a product mixing
    // a linked-image option with a second option has not been exercised.
    options.forEach(function (opt) {
      applyOption(scope, opt.name, opt.value);
    });
  });
})();
